import {
  AfterContentInit,
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  DoCheck,
  ElementRef,
  EventEmitter, forwardRef, HostBinding,
  Input,
  IterableDiffers, OnDestroy, OnInit,
  Output,
  QueryList,
  Renderer2,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PrimeTemplate } from 'primeng/api';
import { DomHandler } from 'primeng/dom';
import { PopupService } from '../../../core/services/popup.service';
import { AppUtilityService } from '../../services/app-utility.service';
import { StaticDataStoreService } from '../../services/static-datastore.service';
import { LmsObjUtilsService } from '../lms-obj-utils.service';


export const AUTOCOMPLETE_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AutocompleteComponent),
  multi: true
};
@Component({
  selector: 'lms-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss'],
  // host: {
  //   '[class.p-inputwrapper-filled]': 'filled',
  //   '[class.p-inputwrapper-focus]': 'focus'
  // },
  providers: [LmsObjUtilsService, AUTOCOMPLETE_VALUE_ACCESSOR]
})
export class AutocompleteComponent implements AfterViewInit, AfterViewChecked, DoCheck, ControlValueAccessor, OnDestroy, AfterContentInit, OnInit {

  @Input() minLength = 1;

  // #input (input)="in.value=$event.target.value.toUpperCase()"

  @HostBinding('class.p-inputwrapper-filled') filled = false;
  @HostBinding('class.p-inputwrapper-focus') focus;
  @Input() delay = 300;

  @Input() style: any;

  @Input() styleClass: string;

  @Input() inputStyle: any;

  @Input() inputId: string;

  @Input() inputStyleClass: string;

  @Input() placeholder: string;

  @Input() readonly: boolean;

  @Input() disabled: boolean;

  @Input() maxlength: number;

  @Input() size: number;

  @Input() appendTo: any;

  @Input() autoHighlight: boolean;

  @Input() type = 'text';

  @Output() completeMethod: EventEmitter<any> = new EventEmitter();

  @Output() onSelect: EventEmitter<any> = new EventEmitter();

  @Output() onUnselect: EventEmitter<any> = new EventEmitter();

  @Output() onFocus: EventEmitter<any> = new EventEmitter();

  @Output() onBlur: EventEmitter<any> = new EventEmitter();

  @Output() onDropdownClick: EventEmitter<any> = new EventEmitter();

  @Output() onClear: EventEmitter<any> = new EventEmitter();

  @Input() field: string;

  @Input() scrollHeight = '200px';

  @Input() dropdown: boolean;

  @Input() multiple: boolean;

  @Input() tabindex: number;

  @Input() dataKey: string;

  @Input() emptyMessage: string;

  @Input() immutable = true;

  @Input() isStation = false;

  @Input() enterButtonId: string;

  @ViewChild('in') inputEL: ElementRef;

  @ViewChild('multiIn') multiInputEL: ElementRef;

  @ViewChild('panel') panelEL: ElementRef;

  @ViewChild('multiContainer') multiContainerEL: ElementRef;

  @ContentChildren(PrimeTemplate) templates: QueryList<any>;

  itemTemplate: TemplateRef<any>;

  selectedItemTemplate: TemplateRef<any>;

  value: any;

  _suggestions: any[];


  timeout: any;

  panelVisible = false;

  stopPanelToShow = false;

  documentClickListener: any;

  suggestionsUpdated: boolean;

  highlightOption: any;

  highlightOptionChanged: boolean;

  // focus = false;

  // filled: boolean;

  inputClick: boolean;

  inputKeyDown: boolean;

  noResults: boolean;

  differ: any;

  onModelChange: Function = () => { };

  onModelTouched: Function = () => { };

  constructor(private staticDataStoreService: StaticDataStoreService, public el: ElementRef,
    public renderer: Renderer2,
    public objectUtils: LmsObjUtilsService, public cd: ChangeDetectorRef,
    public differs: IterableDiffers, private appUtilityService: AppUtilityService,
    private popupService: PopupService) {
    this.differ = differs.find([]).create(null);
  }

  ngOnInit() {
    // Component initialization
  }

  @Input() get suggestions(): any[] {
    return this._suggestions;
  }

  set suggestions(val: any[]) {
    this._suggestions = val;

    if (this.immutable) {
      this.handleSuggestionsChange();
    }
  }

  ngDoCheck() {
    if (!this.immutable) {
      const changes = this.differ.diff(this.suggestions);
      if (changes) {
        this.handleSuggestionsChange();
      }
    }
  }

  handleSuggestionsChange() {
    if (this.panelEL && this.panelEL.nativeElement) {
      if (this._suggestions && this._suggestions.length) {
        this.noResults = false;
        this.show();
        this.suggestionsUpdated = true;

        if (this.autoHighlight) {
          this.highlightOption = this._suggestions[0];
        }
      } else {
        this.noResults = true;

        if (this.emptyMessage) {
          this.show();
          this.suggestionsUpdated = true;
        } else {
          this.hide();
        }
      }
    }
  }

  ngAfterContentInit() {
    this.templates.forEach((item) => {
      switch (item.getType()) {
        case 'item':
          this.itemTemplate = item.template;
          break;

        case 'selectedItem':
          this.selectedItemTemplate = item.template;
          break;

        default:
          this.itemTemplate = item.template;
          break;
      }
    });
  }

  ngAfterViewInit() {
    if (this.appendTo) {
      if (this.appendTo === 'body') {
        document.body.appendChild(this.panelEL.nativeElement);
      } else {
        DomHandler.appendChild(this.panelEL.nativeElement, this.appendTo);
      }
    }
  }

  ngAfterViewChecked() {
    if (this.suggestionsUpdated) {
      this.align();
      this.suggestionsUpdated = false;
      // Ensure custom class is applied after suggestions update
      this.addCustomPanelClass();
    }

    if (this.highlightOptionChanged) {
      const listItem = DomHandler.findSingle(this.panelEL.nativeElement, 'li.p-highlight');
      if (listItem) {
        DomHandler.scrollInView(this.panelEL.nativeElement, listItem);
      }
      this.highlightOptionChanged = false;
    }
  }

  writeValue(value: any): void {
    this.value = value;
    this.filled = this.value && this.value !== '';
  }

  registerOnChange(fn: Function): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: Function): void {
    this.onModelTouched = fn;
  }

  setDisabledState(val: boolean): void {
    this.disabled = val;
  }

  onInput(event: KeyboardEvent) {
    if (!this.inputKeyDown) {
      return;
    }

    const value = (<HTMLInputElement>event.target).value;
    if (!this.multiple) {
      this.onModelChange(value);
    }

    if (value.length === 0) {
      this.hide();
      this.onClear.emit(event);
    }

    if (value.length >= this.minLength) {
      // Cancel the search request if user types within the timeout
      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(() => {
        this.search(event, value);
      }, this.delay);
    } else {
      this.suggestions = null;
    }
    this.updateFilledState();
    this.inputKeyDown = false;
  }

  onInputClick(event: MouseEvent) {
    if (this.documentClickListener) {
      this.inputClick = true;
    }
  }

  search(event: any, query: string) {
    // allow empty string but not undefined or null
    if (query === undefined || query === null) {
      return;
    }

    this.completeMethod.emit({
      originalEvent: event,
      query: query
    });
  }

  selectItem(option: any) {
    if (this.multiple) {
      this.multiInputEL.nativeElement.value = '';
      this.value = this.value || [];
      if (!this.isSelected(option)) {
        this.value = [...this.value, option];
        this.onModelChange(this.value);
      }
    } else {
      this.inputEL.nativeElement.value = this.field ? this.objectUtils.resolveFieldData(option, this.field) || '' : option;
      this.value = option;
      this.onModelChange(this.value);
    }

    this.onSelect.emit(option);

    this.focusInput();
  }

  show() {
    if (this.multiInputEL || this.inputEL) {
      const hasFocus = this.multiple ? document.activeElement === this.multiInputEL.nativeElement : document.activeElement === this.inputEL.nativeElement;
      if (!this.panelVisible && hasFocus && !this.stopPanelToShow) {
        this.panelVisible = true;
        this.panelEL.nativeElement.style.zIndex = ++DomHandler.zindex;
        DomHandler.fadeIn(this.panelEL.nativeElement, 200);
        this.bindDocumentClickListener();
        
        // Patch: Add custom class to panel for targeted styling
        this.addCustomPanelClass();
      }
    }
  }

  private addCustomPanelClass() {
    if (this.panelEL && this.panelEL.nativeElement) {
      // Check for the specific inputIds of the problematic autocompletes
      const isProblematicAutocomplete = this.inputId === 'locoDataTerminalSuggstInput' || 
                                       this.inputId === 'locoDataAddLocoInput';
      
      if (isProblematicAutocomplete) {
        this.panelEL.nativeElement.classList.add('problematic-panel');
      } else {
        this.panelEL.nativeElement.classList.remove('problematic-panel');
      }
    }
  }

  align() {
    if (this.appendTo) {
      DomHandler.absolutePosition(this.panelEL.nativeElement, (this.multiple ? this.multiContainerEL.nativeElement : this.inputEL.nativeElement));
    } else {
      DomHandler.relativePosition(this.panelEL.nativeElement, (this.multiple ? this.multiContainerEL.nativeElement : this.inputEL.nativeElement));
    }
  }

  hide() {
    this.panelVisible = false;
    this.unbindDocumentClickListener();
  }

  handleDropdownClick(event) {
    this.focusInput();
    const queryValue = this.multiple ? this.multiInputEL.nativeElement.value : this.inputEL.nativeElement.value;
    this.onDropdownClick.emit({
      originalEvent: event,
      query: queryValue
    });
  }

  focusInput() {
    if (this.multiple) {
      this.multiInputEL.nativeElement.focus();
    } else {
      this.inputEL.nativeElement.focus();
    }
  }

  removeItem(item: any) {
    const itemIndex = DomHandler.index(item);
    const removedValue = this.value[itemIndex];
    this.value = this.value.filter((val, i) => i !== itemIndex);
    this.onUnselect.emit(removedValue);
    this.onModelChange(this.value);
  }

  onKeydown(event) {
    if (this.enterButtonId && this.enterButtonId.length > 0) {
      this.popupService.setSubmitBtnId(this.enterButtonId);
    }
    if (this.value && this.value.length > 0) {
      this.value = this.value.toUpperCase();
    }
    if (this.value && (this.value.length < 2 && this.value.length >= 0)) {
      this.highlightOption = null;
    }
    this.stopPanelToShow = false;
    if (this.panelVisible) {
      const highlightItemIndex = this.findOptionIndex(this.highlightOption);

      switch (event.which) {
        // down
        case 40:
          if (highlightItemIndex !== -1) {
            const nextItemIndex = highlightItemIndex + 1;
            if (nextItemIndex !== (this.suggestions.length)) {
              this.highlightOption = this.suggestions[nextItemIndex];
              this.highlightOptionChanged = true;
            }
          } else {
            this.highlightOption = this.suggestions[0];
          }

          event.preventDefault();
          break;

        // up
        case 38:
          if (highlightItemIndex > 0) {
            const prevItemIndex = highlightItemIndex - 1;
            this.highlightOption = this.suggestions[prevItemIndex];
            this.highlightOptionChanged = true;
          }

          event.preventDefault();
          break;

        // enter
        case 13:
          if (this.highlightOption) {
            this.selectItem(this.highlightOption);
            this.hide();
          }
          event.preventDefault();
          break;

        // escape
        case 27:
          this.hide();
          event.preventDefault();
          break;


        // tab
        case 9:
          if (this.highlightOption) {
            this.value = this.highlightOption;
            this.onModelChange(this.value);
            this.selectItem(this.value);
          } else if (!this.highlightOption && this.suggestions && this.suggestions.length > 0) {
            this.value = this.suggestions[0];
            this.onModelChange(this.value);
            this.selectItem(this.value);
          } else if (!this.highlightOption && (!this.suggestions || this.suggestions.length < 1) && this.value && this.value.length > 1) {
            if (!this.isStation) {
              this.value = this.getTerminialWhenNoSuggestionFound(this.value);
              this.onModelChange(this.value);
              this.selectItem(this.value);
            } else {
              this.value = this.getStationWhenNoSuggestionFound(this.value);
              this.onModelChange(this.value);
              this.selectItem(this.value);
            }
          }
          this.hide();
          break;
        case 8:
          if (this.value && this.value.length > 0) {
            this.highlightOption = null;
          }
          break;
      }
    } else {
      if (event.which === 40 && this.suggestions) {
        this.search(event, event.target.value);
      } else if (event.which === 9) {
        this.stopPanelToShow = true;
        if (!this.isStation) {
          this.value = this.getTerminialWhenNoSuggestionFound(this.value);
          this.onModelChange(this.value);
          this.selectItem(this.value);
        } else {
          this.value = this.getStationWhenNoSuggestionFound(this.value);
          this.onModelChange(this.value);
          this.selectItem(this.value);
        }
        this.hide();
      }
    }

    if (this.multiple) {
      switch (event.which) {
        // backspace
        case 8:
          if (this.value && this.value.length && !this.multiInputEL.nativeElement.value) {
            this.value = [...this.value];
            const removedValue = this.value.pop();
            this.onUnselect.emit(removedValue);
            this.onModelChange(this.value);
          }
          break;
      }
    }

    this.inputKeyDown = true;
  }

  onInputFocus(event) {
    this.focus = true;
    this.onFocus.emit(event);
  }

  onInputBlur(event) {
    this.focus = false;
    this.onModelTouched();
    this.onBlur.emit(event);
  }

  isSelected(val: any): boolean {
    let selected = false;
    if (this.value && this.value.length) {
      for (let i = 0; i < this.value.length; i++) {
        if (this.objectUtils.equals(this.value[i], val, this.dataKey)) {
          selected = true;
          break;
        }
      }
    }
    return selected;
  }

  findOptionIndex(option): number {
    let index: number = -1;
    if (this.suggestions) {
      for (let i = 0; i < this.suggestions.length; i++) {
        if (this.objectUtils.equals(option, this.suggestions[i])) {
          index = i;
          break;
        }
      }
    }

    return index;
  }

  updateFilledState() {
    if (this.multiple) {
      this.filled = (this.value && this.value.length) || (this.multiInputEL && this.multiInputEL.nativeElement && this.multiInputEL.nativeElement.value !== '');
    } else {
      this.filled = this.inputEL && this.inputEL.nativeElement && this.inputEL.nativeElement.value !== '';
    }
  }

  bindDocumentClickListener() {
    if (!this.documentClickListener) {
      this.documentClickListener = this.renderer.listen('document', 'click', (event) => {
        if (event.which === 3) {
          return;
        }

        if (this.inputClick) {
          this.inputClick = false;
        } else {
          this.hide();
        }

        this.cd.markForCheck();
      });
    }
  }

  unbindDocumentClickListener() {
    if (this.documentClickListener) {
      this.documentClickListener();
      this.documentClickListener = null;
    }
  }

  private getTerminialWhenNoSuggestionFound(inputText: string) {
    const mnemonics = [];
    const mileposts = [];
    let filteredResults = [];
    let commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    commonopsPicklist = this.appUtilityService.validateCommonPickList(commonopsPicklist);
    if (commonopsPicklist) {
      const data = commonopsPicklist.mapOfMnemonis ? commonopsPicklist.mapOfMnemonis : null;
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          mnemonics.push(data[key]);
          mileposts.push(key);
        }
      }
    }
    filteredResults = mnemonics.filter((s) => {
      return s.startsWith(inputText.toUpperCase());
    });

    Array.prototype.push.apply(filteredResults, (mileposts.filter((s) => {
      return s.startsWith(inputText.toUpperCase());
    })));

    filteredResults = filteredResults.filter(function (item, index, inputArray) {
      return inputArray.indexOf(item) === index;
    });
    filteredResults.sort();
    if (filteredResults && filteredResults.length > 0) {
      return filteredResults[0];
    }
  }

  private getStationWhenNoSuggestionFound(inputText: string) {
    let filteredResults = [];
    let commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    commonopsPicklist = this.appUtilityService.validateCommonPickList(commonopsPicklist);
    if (commonopsPicklist && commonopsPicklist.masterData) {
      const allocationStationArr = commonopsPicklist.masterData.allocationStationList;
      for (const allocStation of allocationStationArr) {
        filteredResults.push(allocStation.allocationStation);
      }
      filteredResults = filteredResults.filter((s) => {
        return s.startsWith(inputText.toUpperCase());
      });
      filteredResults.sort();
    }
    if (filteredResults && filteredResults.length > 0) {
      return filteredResults[0];
    }
  }

  ngOnDestroy() {
    this.unbindDocumentClickListener();

    if (this.appendTo) {
      this.el.nativeElement.appendChild(this.panelEL.nativeElement);
    }
  }

}
